import config from 'src/config';
import { events } from './events';
import AlertManager from '../components/alert/AlertManager';
import LANG_CONST from './lang/const';
import { permissions } from './permissions';

let Notification = window.Notification;

if (typeof Notification === 'undefined') {
  Notification = {
    permission: 'disabled',
    requestPermission: async function () {
      return 'disabled';
    }
  };
}

class CustomNotification {
  permission = Notification.permission;

  enableRequestPermission = false;
  constructor() {
    document.addEventListener('click', this.initRequestPermission);
  }

  initRequestPermission = () => {
    this.enableRequestPermission = true;
  };

  sendNotification(title, message, data) {
    if (this.permission === 'granted') {
      const notification = new Notification(title, {
        body: message
      });
      notification.onclick = (event) => {
        // prevent the browser from focusing on the Notification's tab
        event.preventDefault();
        if (data.from) window.open('https://www.lifeapp.com/messages/' + data.from, '_blank');
      };
    }
  }
  requestPermission(user) {
    this.user = user;
    document.removeEventListener('click', this.initRequestPermission);
    if (this.enableRequestPermission) {
      this._requestPermission();
    } else {
      document.addEventListener('click', this._requestPermission);
    }
  }

  _showPopup = (cb) => {
    AlertManager.popup(
      AlertManager.TYPES.INFO,
      {
        title: LANG_CONST.titles.enable_chat_notification,
        body: LANG_CONST.text.enable_chat_notification,
        noBodyBorder: true,
        isTitleCenter: true,
        icon: false,
        iconTemplate: 'primary',
        close: true,
        maxWidth: 480,
        actionButton: {
          label: LANG_CONST.buttons.enable,
          action: ({ hide }) => {
            hide();
            cb(true);
          }
        },
        cancelButton: {
          label: LANG_CONST.buttons.not_now,
          action: ({ hide }) => {
            hide();
            cb(false);
          }
        }
      },
      {
        active: false,
        activeByRouter: ({ location }) => {
          const match = permissions.findMatchPath(location.pathname);

          if (!match) return true;
          return match.webType === 'front' && !match.isAuthPage;
        }
      }
    );
  };

  clearListeners = () => {
    document.removeEventListener('click', this.initRequestPermission);
    document.removeEventListener('click', this._requestPermission);
  };

  _requestPermission = () => {
    try {
      document.removeEventListener('click', this._requestPermission);
      if (Notification.permission === 'denied') {
        this.permission = 'denied';
        events.emit('notification:requestPermission', 'denied');
        return;
      }

      if (!config.get('features')?.chatNotificationPrompt) return;

      let userId = this.user?.id;
      let permission = localStorage.getItem('webpush_permission');
      if (permission) permission = JSON.parse(permission);
      let maxTimeout = 1000 * 60 * 60 * 24 * 365;
      if (
        permission &&
        permission.userId === userId &&
        !permission.granted &&
        Date.now() - permission.date < maxTimeout
      ) {
        console.log('notifications _requestPermission ignore');
        return;
      }

      this._showPopup((granted) => {
        console.log('_showPopup callback', granted);
        if (granted) {
          Notification.requestPermission().then((perm) => {
            console.log('notifications permission', perm);
            localStorage.setItem(
              'webpush_permission',
              JSON.stringify({ userId, date: Date.now(), granted: perm === 'granted' })
            );
            events.emit('notification:requestPermission', perm);
            this.permission = perm;
          });
        } else {
          localStorage.setItem(
            'webpush_permission',
            JSON.stringify({ userId, date: Date.now(), granted: false })
          );
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  requestPermissionDirect = () => {
    if (Notification.permission === 'granted') {
      this.permission = 'granted';
      events.emit('notification:requestPermission', 'granted');
      return;
    }
    if (Notification.permission === 'denied') {
      this.permission = 'denied';
      AlertManager.popup(AlertManager.TYPES.INFO, {
        title: LANG_CONST.titles.notifications_blocked,
        body: LANG_CONST.text.notifications_blocked,
        icon: false,
        iconTemplate: 'primary',
        close: true,
        maxWidth: 380
      });
      events.emit('notification:requestPermission', 'denied');
      return;
    }
    Notification.requestPermission().then((perm) => {
      this.permission = perm;
      localStorage.setItem(
        'webpush_permission',
        JSON.stringify({ userId: this.user?.id, date: Date.now(), granted: perm === 'granted' })
      );
      events.emit('notification:requestPermission', perm);
    });
  };
}

export const notification = new CustomNotification();
